"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.update = void 0;
var spritesUiTop_1 = require("@crokinole/recyclers/spritesUiTop");
var mathUtils_sidecar_1 = require("@lib/mathUtils-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var sprites_sidecar_1 = require("@sprites/sprites-sidecar");
var update = function () {
    if (!common_sidecar_1.common.getIsFocused()) {
        // rogueMonofont.write(1, 1, 'Click to focus')
        var imgTitle = spritesUiTop_1.spritesUiTop.getNext(1, 1, sprites_sidecar_1.sprites.crokinoleCrokinoleTitle[0]);
        imgTitle.rotation = mathUtils_sidecar_1.mathUtils.turn(-1 / 8);
        imgTitle.x = 120;
        imgTitle.y = 120;
        var imgClickToFocus = spritesUiTop_1.spritesUiTop.getNext(1, 1, sprites_sidecar_1.sprites.crokinoleClickToFocus[0]);
        imgClickToFocus.rotation = mathUtils_sidecar_1.mathUtils.turn(-1 / 8);
        imgClickToFocus.x = 180;
        imgClickToFocus.y = 180;
    }
};
exports.update = update;
